export default __webpack_public_path__ + "static/hand-holding-dollar-light.png";